import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import ConnectedHeader from '../connectedComponents/ConnectedHeader.js';
import { apis } from '../api';
import './verify.css';

class VerifyForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tips: '账号验证中...',
    };
  }

  static propTypes = {
    user: PropTypes.object,
    history: PropTypes.object,
    getUrlParam: PropTypes.func,
  };

  componentDidMount() {
    this.verify();
  }

  verify = () => {
    const post = { userid: this.props.getUrlParam('userid') };

    apis.verify(post).then(result => {
      this.setState({
        success: result.code === '0' ? true : false,
        tips: result.code === '0' ? '账号验证成功' : result.message,
      });
    });
  };

  goLogin = () => {
    this.props.history.push('/login');
  };

  render() {
    const { success } = this.state;
    const successColor = { color: '#52c41a' };
    const failColor = { color: '#f5222d' };
    const fontSize = { fontSize: '60px' };
    return (
      <div className="reg-page-bg">
        <ConnectedHeader login={true} home={true} user={this.props.user} />
        <div className="register-box">
          <div className="center-form">
            <div className="verify-text">
              <p className="form-tit">邮箱验证</p>
              <p>
                <Icon
                  type={success ? 'check-circle' : 'close-circle'}
                  theme="filled"
                  style={
                    success
                      ? { ...successColor, ...fontSize }
                      : { ...failColor, ...fontSize }
                  }
                />
              </p>

              <p
                className="verify-tips"
                style={success ? successColor : failColor}
              >
                {this.state.tips}
              </p>
              {success && (
                <p className="verify-tips1">
                  邮箱验证成功，账号已<span>成功激活</span>立即登录体验产品
                </p>
              )}

              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                block
                size="large"
                onClick={this.goLogin}
                history={this.props.history}
              >
                去登录
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(VerifyForm);
